import { ClipboardCheck, UserCheck, Droplets, Banknote } from "lucide-react";

const steps = [
  {
    icon: ClipboardCheck,
    step: "1",
    title: "Anmeldung",
    description:
      "Online oder vor Ort im Plasmazentrum registrieren und ersten Termin vereinbaren. Spendernummer für Bonus nicht vergessen!",
  },
  {
    icon: UserCheck,
    step: "2",
    title: "Gesundheitscheck",
    description:
      "Kurze ärztliche Untersuchung und medizinischen Fragebogen ausfüllen. Beim Ersttermin etwas mehr Zeit einplanen.",
  },
  {
    icon: Droplets,
    step: "3",
    title: "Plasmaspende",
    description:
      "Die eigentliche Spende dauert je nach Anbieter etwa 30–55 Minuten. Für den regulären Besuch zusätzliche Zeit für Anmeldung, Untersuchung und Erholung einplanen.",
  },
  {
    icon: Banknote,
    step: "4",
    title: "Aufwandsentschädigung",
    description:
      "Nach der Spende erhalten Sie ca. 30 Euro bar. Durch Aktionen und Boni ist mehr möglich!",
  },
];

const Process = () => {
  return (
    <section
      className="section-screen bg-muted/30 min-h-[100svh] md:min-h-screen scroll-mt-20 md:scroll-mt-0"
      id="ablauf"
      aria-labelledby="process-heading"
    >
      <div className="container container-narrow">
        <h2
          id="process-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-4 font-display"
        >
          <span className="text-foreground">So funktioniert die </span>
          <span className="text-gradient">Plasmaspende</span>
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-xl mx-auto text-lg">
          In vier einfachen Schritten zum Plasmaspender werden
        </p>

        <div className="relative">
          {/* Connection line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-primary/30 to-primary/30 z-0" />

          <div className="grid md:grid-cols-4 gap-6 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="group">
                <div className="glass-card p-6 h-full flex flex-col items-center text-center relative hover:-translate-y-1 transition-transform duration-300">
                  {/* Step Number Badge */}
                  <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-lg mb-4 shadow-lg shadow-primary/25 z-20">
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div className="mb-4 text-primary p-3 bg-primary/10 rounded-2xl group-hover:bg-primary/20 transition-colors">
                    <step.icon className="w-8 h-8" />
                  </div>

                  <h3 className="font-display font-bold text-lg mb-2 w-full break-words hyphens-auto">
                    {step.title}
                  </h3>

                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
